import React from 'react';
import { useTranslation } from 'react-i18next';
import { apiService } from '../../../api/apiClient';
import AuditFiltersBar from '../AuditFiltersBar';
import AuditTable, { statusPill, formatTs, monoShort } from '../AuditTable';
import InfoBox from '../InfoBox';
import useAuditList from '../useAuditList';

export default function IngestionTab() {
  const { t } = useTranslation();
  const { rows, loading, filters, setFilters, offset, limit, next, prev } =
    useAuditList(apiService.listAuditIngestion);

  const columns = [
    { key: 'run_id', header: t('traceability:columns.runId'),
      render: (r) => monoShort(r.run_id, 10) },
    { key: 'started_at', header: t('traceability:columns.startedAt'), render: (r) => formatTs(r.started_at) },
    { key: 'ended_at', header: t('traceability:columns.endedAt'), render: (r) => formatTs(r.ended_at) },
    { key: 'source', header: t('traceability:columns.source') },
    { key: 'rows_total', header: t('traceability:columns.rowsOut') },
    { key: 'status', header: t('traceability:columns.status'), render: (r) => statusPill(r.status) },
    { key: 'event_count', header: '#events' },
  ];

  return (
    <div>
      <InfoBox tabKey="ingestion" />
      <AuditFiltersBar value={filters} onChange={setFilters} showTraceId={false} />
      <AuditTable rows={rows} columns={columns} loading={loading}
                  limit={limit} offset={offset} onNext={next} onPrev={prev} />
    </div>
  );
}
